import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiRequestService, FilterPipe, ToastmessageService, TranslationService } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetProductsResponse } from '../../products/product-list/get-products.response';
import { Material } from '../../products/product-list/material.model';
import { BookWithSerienumber } from '../addserie/bookwithserienumber';
import { Serie } from '../serie';
import { AddProductToSerieRequest } from './addproducttoserierequest';
import { AddProductToSerieResponse } from './addproducttoserieresponse';
import { GetSerieRequest } from './getserierequest';
import { GetSerieResponse } from './getserieresponse';

@Component({
    selector: 'app-addproductstoserie',
    templateUrl: './addproductstoserie.component.html',
    styleUrls: ['./addproductstoserie.component.scss'],
    standalone: true,
    imports: [MatIconModule, FilterPipe, FormsModule]
})
export class AddproductstoserieComponent implements OnInit {
    addProductToSerieRequest: AddProductToSerieRequest = {};

    addProductToSerieResponse: AddProductToSerieResponse = {};

    @Input()
    existingProducts: BookWithSerienumber[] = [];

    filteredBooks: Material[] = [];

    @Input()
    filteredProduct: Material[] = [];

    getSerieRequest: GetSerieRequest = {};

    getSerieResponse: GetSerieResponse = {};

    getSerieUrl = '/admin/getSerieWithProducts';

    isExtraSmall: Observable<BreakpointState>;

    products: Material[] = [];

    productsForASerie: BookWithSerienumber[] = [];

    productsToChooseToUpdate: Material[] = [];

    routerLink = '';

    @Input() routerLinkAddSerie = '';

    searchText = '';

    selectedBook: Material = {};

    selectedBook2: Material = {};

    @Input()
    selectedBookList: BookWithSerienumber[] = [];

    serie: Serie = {};

    @Input()
    serieForm?: FormGroup;

    @Input() serieName = '';

    serieNumber = 0;

    serieNumberForm?: FormGroup;

    serieNumberToAdd = 0;

    storeBaseUrl = '';

    storeExistingProductsURI = '/store/get-products';

    private _listFilter = '';

    get listFilter(): string {
        return this._listFilter;
    }

    set listFilter(value: string) {
        this._listFilter = value;
        this.filteredBooks = this.performFilter(value);
    }

    constructor(
        public _router: Router,
        private _fb: FormBuilder,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService,
        private _translateService: TranslationService,
        private _route: ActivatedRoute,
        private readonly breakpointObserver: BreakpointObserver
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.createSerieNumberForm();
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            const lastSegmentOfUrl = window.location.href.split('/').pop();
            this.routerLink = lastSegmentOfUrl as string;

            this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.storeExistingProductsURI).subscribe((response) => {
                const products = response as GetProductsResponse;
                this.products = products.productList as Material[];
                this.productsToChooseToUpdate = products.productList as Material[];
                this.filteredBooks = this.productsToChooseToUpdate;
                this.getSerieRequest = {
                    routerLink: this.routerLink
                };
                this._apiRequestService
                    .sendRequest<GetSerieRequest, GetSerieResponse>(this.storeBaseUrl, this.getSerieRequest, true, this.getSerieUrl)
                    .subscribe((response) => {
                        this.serie = response.serie as Serie;
                        this.products.forEach((product) => {
                            if (product.serieId === this.serie.id) {
                                const index = this.productsToChooseToUpdate.indexOf(product);
                                this.productsToChooseToUpdate.splice(index, 1);
                                const existingBook = {
                                    book: product,
                                    serieNumber: product.serieNumber
                                };
                                this.productsForASerie.push(existingBook);
                                this.selectedBookList.push(existingBook);
                            }
                            this.selectedBookList.sort((a, b) => a.serieNumber! - b.serieNumber!);
                        });
                    });
            });
        } else {
            this._router.navigateByUrl('/');
        }
    }

    performFilter(filterBy: string): Material[] {
        filterBy = filterBy.toLocaleLowerCase();
        return this.products.filter(
            (publication: Material) =>
                publication.title?.toLocaleLowerCase().includes(filterBy) || publication.author?.toLocaleLowerCase().includes(filterBy)
        );
    }

    createSerieNumberForm() {
        this.serieNumberForm = this._fb.group({
            serieNumber: ['', [Validators.required]]
        });
    }

    collectSerieNumber() {
        this.serieNumber = this.serieNumberForm?.controls['serieNumber'].value as number;
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    addProduct(product: Material) {
        this.serieNumberToAdd = this.serieNumberToAdd + 1;
        const bookWithSeriNumber: BookWithSerienumber = {
            book: product,
            serieNumber: this.serieNumberToAdd
        };
        const index = this.products.indexOf(product);
        this.products.splice(index, 1);
        this.selectedBookList.push(bookWithSeriNumber);
    }

    addNewProduct() {
        const bookWithSeriNumber: BookWithSerienumber = {
            book: this.selectedBook2,
            serieNumber: this.serieNumberForm?.controls['serieNumber'].value as number
        };
        const index = this.productsToChooseToUpdate.indexOf(this.selectedBook);
        this.productsToChooseToUpdate.splice(index, 1);
        this.existingProducts.push(bookWithSeriNumber);
    }

    deleteFromExistingSerie(existingProduct: BookWithSerienumber) {
        const index = this.existingProducts.indexOf(existingProduct);
        this.existingProducts.splice(index, 1);
        this.productsToChooseToUpdate.push(existingProduct.book!);
    }

    deleteFromSerie(selectedBookList: BookWithSerienumber) {
        const index = this.selectedBookList.indexOf(selectedBookList);
        this.selectedBookList.splice(index, 1);
        this.products.push(selectedBookList.book!);
    }

    addBookToSerie(product: Material) {
        this.selectedBook = product;
        this.filteredProduct = [];
    }

    increaseSerieNumber(selectedBook: BookWithSerienumber) {
        const index = this.selectedBookList.indexOf(selectedBook);
        const i = index + 1;
        this.selectedBookList.forEach((selectedBookElement) => {
            if (this.selectedBookList[i].book?.id === selectedBookElement.book?.id) {
                selectedBookElement.serieNumber = i;
            }
        });
        this.selectedBookList = this.move(index, index + 1, this.selectedBookList);
        this.selectedBookList.forEach((selectedBookElement) => {
            if (selectedBook.book?.id === selectedBookElement.book?.id) {
                selectedBookElement.serieNumber = index + 2;
            }
        });
    }

    decreaseSerieNumber(selectedBook: BookWithSerienumber) {
        const index = this.selectedBookList.indexOf(selectedBook);
        const i = index - 1;
        this.selectedBookList.forEach((selectedBookElement) => {
            if (this.selectedBookList[i].book?.id === selectedBookElement.book?.id) {
                selectedBookElement.serieNumber = i + 2;
            }
        });
        this.selectedBookList = this.move(index, index - 1, this.selectedBookList);
        this.selectedBookList.forEach((selectedBookElement) => {
            if (selectedBook.book?.id === selectedBookElement.book?.id) {
                selectedBookElement.serieNumber = index;
            }
        });
    }

    move(from: number, to: number, selectedBook: BookWithSerienumber[]): BookWithSerienumber[] {
        const newArr = [...selectedBook];

        const item = newArr.splice(from, 1)[0];
        newArr.splice(to, 0, item);

        return newArr;
    }
}
